import UserClient from '@book24/client-api/dist/clients/UserClient';
import $http from '@/js/repositories/httpClient';

export const getUserInfo = () => new UserClient($http).userGetInfo();

export const userLogin = payload => new UserClient($http).userLogin(payload);

export const userLogout = () => new UserClient($http).userLogout();

export const userRegister = payload => new UserClient($http).userRegister(payload);

export const userUpdate = payload => new UserClient($http).userUpdate(payload);

export const userPasswordRecovery = payload => new UserClient($http).userPasswordRecovery(payload);

export const userCheckProblem = payload => new UserClient($http).checkUserProblem(payload);

export const userCheckEmailAvailability = payload => new UserClient($http)
  .checkEmailAvailability(payload);

export const userSendConfirmCode = payload => new UserClient($http).sendConfirmCode(payload);

export const userSendReceivedCode = payload => new UserClient($http).sendReceivedCode(payload);

export const userCallOrder = payload => new UserClient($http).callOrder(payload);
